import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AutofillDirective } from 'src/app/shared/directives/autofill.directive';

@Component({
    selector: 'app-auth-forgot-password-form',
    templateUrl: './auth-forgot-password-form.component.html',
    styleUrls: ['./auth-forgot-password-form.component.scss'],
    imports: [ReactiveFormsModule, CommonModule, IonicModule, AutofillDirective, NgOptimizedImage],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthResetPasswordFormComponent  implements OnInit {
  emailForm!: FormGroup;

  readonly resetOnSubmit = input(false);
  readonly resetOnAuthModeChange = input(false);
  readonly loading = input<boolean>(false);
  @Output() modeChange = new EventEmitter<string>();
  @Output() submit = new EventEmitter<string>();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
      this.emailForm = this.fb.group({
          email: ['', [Validators.required, Validators.email]],
      });
  }

  handleChange(e: Event) {
      e.preventDefault();
      this.modeChange.emit('signIn');
      if (this.resetOnAuthModeChange()) {
          this.emailForm.reset();
      }
  }

  async handleSubmit() {
      const email = this.emailForm.value['email'];
      this.submit.emit(email);
      if (this.resetOnSubmit()) {
          this.emailForm.reset();
      }
  }
}
